import Carousel from 'nuka-carousel';
import styled from '@emotion/styled';

import { Box, Flex } from '@toolbox/components';
import { useMarketTrends } from '@widget/core';
import { BREAKPOINTS, useBreakpoint } from '../../utils/useBreakpoint';
import { USPItemOld as USPItem } from '../USPItem';

import type { USPItemProps } from '../USPItem';

type LocalizedUspListProps = {
  label?: string | null;
  uspLayout?: 'vertical' | 'horizontal' | null;
  forceMobileMode: boolean;
};

export const LabelContainer = styled(Flex)`
  font-size: 12px;
  ${({ theme }) => theme.media.up('md')} {
    font-size: 14px;
  }
`;

export const StyledBox = styled(Box)`
  max-width: 100vw;
`;

export const LocalizedUspListOld = ({
  label,
  uspLayout,
  forceMobileMode,
}: LocalizedUspListProps): JSX.Element => {
  const breakpoint = useBreakpoint() || '';
  const isPhoneScreen = [BREAKPOINTS.xs, BREAKPOINTS.sm].includes(breakpoint);
  const { marketTrends } = useMarketTrends();

  if (!marketTrends) {
    return <></>;
  }

  const upsItemsList: USPItemProps[] = [
    {
      label: `⌀ ${marketTrends.averageSqmPrice} Euro/m²`,
      icon: 'avgSMPricePerRegionIcon',
      iconBig: true,
    },
    {
      label: `⌀ ${marketTrends.averageSellingTime} Tage bis zum Verkauf`,
      icon: 'sellingHorizon',
      iconBig: true,
    },
    {
      label: `${marketTrends.brokerCount} Makler vor Ort`,
      icon: 'nrofBrokersPerRegion',
      iconBig: true,
    },
  ];

  const isSliderMode = forceMobileMode || (isPhoneScreen && uspLayout !== 'vertical');

  return (
    <>
      {isSliderMode && (
        <Carousel
          autoplay
          wrapAround
          defaultControlsConfig={{
            nextButtonStyle: {
              display: 'none',
            },
            prevButtonStyle: {
              display: 'none',
            },
            pagingDotsStyle: {
              display: 'none',
            },
          }}
        >
          {upsItemsList?.map((props, index) => (
            <USPItem key={index} {...props} />
          ))}
        </Carousel>
      )}
      {!isSliderMode && (
        <>
          <LabelContainer alignItems={'center'} css={{ marginLeft: '0rem' }}>
            {label}
          </LabelContainer>
          {upsItemsList?.map((props, index) => (
            <USPItem key={index} {...props} />
          ))}
        </>
      )}
    </>
  );
};
